import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ loading, confirmationDialog }) => {
  return (
    <div id="continue_button" style={{ marginTop: 20, textAlign: 'center' }}>
      {!loading ? (
        <span>
          <button type="submit" className="frg-button button-wide color-green">
            {confirmationDialog.confirm}
          </button>
        </span>
      ) : (
        <span>
          <button className="frg-button button-wide color-green" type="button">
            <i className="fa fa-refresh fa-spin" />
            {confirmationDialog.LOADING}
          </button>
        </span>
      )}
    </div>
  );
};

Button.propTypes = {
  loading: PropTypes.bool.isRequired,
  confirmationDialog: PropTypes.isRequired
};

export default Button;
